<template>
<basicContainer> <avue-empty
    :desc="tips">
  </avue-empty></basicContainer>

</template>

<script>
export default {
  data() {
    return {
      tips: ''
    }
  },
  mounted() {
    let { tips } = this.$route.query
    this.tips = tips
  }

}
</script>
